import { colors } from 'theme'

export const defaultThemeStyles = {
    'info': colors.white,
    'errorBackground': colors.error,
    'tag': colors.white,
}
